<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2026-03-31 09:57:39
-->
<template>
  <div>
    <!--    -->
    <mrc_ess_table
      v-if="$route.name == 'businessApply'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-on-behalf-application-configuration')"
      pageName="addBusinessApply"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['uuid', 'Date']"
      :items="desserts"
    >
      <template v-slot:btns>
        <mrc_ess_uploadBtn
          type="9"
          :hrefUrl="uploadUrl"
       v-btnAuth="['import-on-behalf-application-configuration']" 
          class="ml-4"
          :label="$t('label_Batch_Import')"
        ></mrc_ess_uploadBtn>
      </template>
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.uuid="{ item }">
        <mrc_ess_staffListView
          itemValue="user_id"
          :staffuuid="item.on_behalf_staff_uuid"
          :allList="allList"
        ></mrc_ess_staffListView>
      </template>
      <template v-slot:item.Date="{ item }">
        {{ item.effective_utc_start_date | changeDate() }}
        <span class="mx-1">-</span>
        {{ item.effective_utc_end_date | changeDate() }}
      </template>
      <!-- 操作 -->
      <!-- -->
      <template v-slot:item.actions="{ item }">
        <menu-list
          :list="[
            {
              name: $t('label_View'),
              type: 'view',
              show: hasBtn('view-on-behalf-application-configuration'),
            },
            {
              name: $t('label_Edit'),
              type: 'edit',
              show: hasBtn('edit-on-behalf-application-configuration'),
            },
            {
              name: $t('label_delete'),
              type: 'del',
              show: hasBtn('delete-on-behalf-application-configuration'),
            },
          ]"
          @handleClick="handleClick($event, item)"
        >
          <template v-slot:showAction>
            <!---->
            <v-icon
              v-btnAuth="[
                'view-on-behalf-application-configuration',
                'edit-on-behalf-application-configuration',
                'delete-on-behalf-application-configuration',
              ]"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
        <!-- 
        :showEdit="hasBtn('edit-on-behalf-application-configuration')"
        :show_del="hasBtn('delete-on-behalf-application-configuratio')"
        ,type: 'view'
        ,type: 'edit'
        ,type: 'del'
        'view'
        'edit'
        'del'
         -->
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import {
  getBusinessApplyList,
  addBusinessApply,
  updateBusinessApply,
  deleteBusinessApply,
  detailBusinessApply,
} from "@/service/api/businessApply.js";
import { ON_BEHALF_APPLICATION_URL } from "@/utils/constant/index.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      allList: [],
      stepIndex: 1,
      disabled: true,
      list: {},
      uploadUrl: "",
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_acting_employee"),
          align: "start",
          value: "uuid",
          sortable: false,
        },
        { text: this.$t("label_Date"), value: "Date", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "businessApply") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.uploadUrl = ON_BEHALF_APPLICATION_URL;
    this.loading = true;
    await this.getdropDownList();
    await this.getlist();
    this.loading = false;
    // this.advanceList = await this.$store.dispatch('getPromptData', { prompt_name: 'staffs', org_level_uuid: this.$store.state.currentCompany })
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
  },
  methods: {
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.allList = res.data;
      }
    },
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await getBusinessApplyList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "");
      this.$store.commit("set_uuid", "");
      this.$store.commit("set_iconstatus", ""); //行内进图标显示
      this.$router.push({
        name: "addBusinessApply",
      });
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      // this.$store.commit('set_subPage_name', item.job_name)
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailBusinessApply",
      });
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          // this.$store.commit('set_subPage_name', obj.job_name)
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid); //
          this.$router.push({
            name: "detailBusinessApply",
          });
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteBusinessApply({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getlist();
              }
            });
          });
          break;
      }
    },
    success() {},
    cancel() {},
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
